import { useMutation } from '@tanstack/react-query'

import { createPaymentLinkRP } from '../paymentsService'

export function useCreateRPPaymentLink() {
  return useMutation({
    mutationFn: createPaymentLinkRP,
  })
}
